import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class HinarioProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  getHinos(pag, filtro) {
    return this.http
      .get<any>(this.baseUrl + '/hinario/get-hinos', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          f: filtro,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          hinos: data.body,
          pagination: pag,
        };
      });
  }

  getHino(id) {
    return this.http
      .post<any>(this.baseUrl + '/hinario/get-hino', {
        id: id,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/hinario/hinario.ts